import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import LinearGradient from '@hfe/max-linear-gradient';
import { Free_Travel_TAG, GROUP_TOUR_TAG, DISCOUNT, CURVE } from '../../utils/constants';
import { venusParams } from '../../utils/formatImage';
import { formatPrice } from '../../utils/formatPrice';
import { jumpToDetail } from '../../utils/jumpUtils';
import { useEffect, createElement } from '@max/max';
const isMRN = false;
import { getSystemInfoSync } from '@max/meituan-uni-system';
import './index.scss';
const Card = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { goodInfo, index, supplyGroupId, _LXReport, pageSourceType } = props;
    const { mvReport, mcReport } = _LXReport;
    const jumpDetail = () => {
        jumpToDetail({
            goodInfo,
            index,
            supplyGroupId,
            pageSourceType,
            mcReport
        });
    };
    const { platform } = getSystemInfoSync() || {};
    const isAndroid = (platform === null || platform === void 0 ? void 0 : platform.toLowerCase()) === "android";
    const handleView = () => {
        mvReport('b_daodian_lowcode_7s2beos5_mv', {
            valLab: {
                deal_id: goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.goodsId,
                biz_line: 'holiday',
                dealgroup_id: supplyGroupId,
                item_index: index
            }
        });
    };
    // 格式化促销金额，处理异常格式如 ' .00 '
    const formatPromotionAmount = (amount) => {
        if (!amount)
            return '0';
        // 如果是字符串，先去除空格
        const cleanAmount = typeof amount === 'string' ? amount.trim() : amount;
        // 处理以点开头的情况，如 '.00'
        const normalizedAmount = String(cleanAmount).replace(/^\s*\./, '0.');
        // 转换为数字
        const numAmount = Number(normalizedAmount);
        // 如果是非法数字，返回0
        if (isNaN(numAmount))
            return '0';
        // 如果是整数，直接返回
        if (Number.isInteger(numAmount))
            return String(numAmount);
        // 保留两位小数，去除末尾的0
        return numAmount.toFixed(2).replace(/\.?0+$/, '');
    };
    useEffect(() => {
        handleView();
    }, []);
    const actualPrice = (_b = (_a = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.promotionPriceDTO) === null || _a === void 0 ? void 0 : _a.payPrice) !== null && _b !== void 0 ? _b : goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.sellPrice;
    const categoryTagKey = (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) === '跟团游' ? 3 : 2;
    const categoryTag = (_d = (_c = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.tags) === null || _c === void 0 ? void 0 : _c.find((item) => (item === null || item === void 0 ? void 0 : item.tagKey) === categoryTagKey)) === null || _d === void 0 ? void 0 : _d.descriptions;
    const productTag = (_f = (_e = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.tags) === null || _e === void 0 ? void 0 : _e.find((item) => (item === null || item === void 0 ? void 0 : item.tagKey) === 1)) === null || _f === void 0 ? void 0 : _f.descriptions;
    const showProductTag = (categoryTag === null || categoryTag === void 0 ? void 0 : categoryTag.length) > 0 ? productTag === null || productTag === void 0 ? void 0 : productTag.slice(0, 4) : productTag;
    // return       <ImageBackground style={{width: '100rpx', height: '100rpx'}} source={image}>
    //     </ImageBackground>
    return <View className="card-container" onClick={() => {
        jumpDetail();
    }}>
      <View className="card-image-view">
        <Image className="card-image" source={{
        uri: venusParams(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.goodsHeadPhoto, 200, 200)
    }}/>
      </View>
      <Image className="card-image-tag" source={{
        uri: (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) === '跟团游' ? GROUP_TOUR_TAG : Free_Travel_TAG
    }}/>
      {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) === '跟团游' && (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.departures) && goodInfo.departures.length > 0 && <View className="departures-container">
          <LinearGradient className="departures-background" start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 0
    }} colors={['rgba(51, 51, 51, 0.6)', 'rgba(51, 51, 51, 0.6)']} style={{
        borderBottomRightRadius: 10
    }}/>
          <Text className="departures-text">
            {goodInfo.departures.length > 1 ? '多地出发' : `${((_g = goodInfo.departures[0]) === null || _g === void 0 ? void 0 : _g.cityName) || 'X X '}出发`}
          </Text>
        </View>}

      <View className="card-content-right">
        <View className="card-top-field">
          <View className="card-tag-field">

            
            <View className="double-card-day-h5-tag-view" style={{
        top: isMRN ? '6rpx' : '5rpx'
    }}>
              <Text className="double-card-day-h5-tag-text">{goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.travelDay}</Text>
            </View>
            <Text className="card-deal-name" numberOfLines={2}>
              {isMRN ? '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0' : isAndroid ? '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0' : '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0'}
              {goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.goodsName}
            </Text>
          </View>
          <View className="card-tag">
            {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) === '跟团游' && (showProductTag === null || showProductTag === void 0 ? void 0 : showProductTag.map((item) => {
        return <View className="card-product-tag-group">
                    <Text className="card-product-tag-text-group">{item}</Text>
                  </View>;
    }))}
            {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) !== '跟团游' && (categoryTag === null || categoryTag === void 0 ? void 0 : categoryTag.map((item) => {
        return <View className="card-people-tag">
                    <Text className="card-people-tag-text">{item}</Text>
                  </View>;
    }))}
            {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) !== '跟团游' && (showProductTag === null || showProductTag === void 0 ? void 0 : showProductTag.map((item) => {
        return <View className="card-product-tag-free">
                    <Text className="card-product-tag-text-free">{item}</Text>
                  </View>;
    }))}
          </View>
        </View>
        <View className="card-bottom-field">
          <View className="card-bottom-left-field">
            <View className="card-price-field">
              <Text className="card-price-icon">¥</Text>
              <Text className="card-price-now" style={{
        fontFamily: isMRN ? 'MTNewDigitalDisplay-Bold' : 'MTNewDigitalDisplay-Regular'
    }}>{formatPrice(actualPrice)}</Text>
              <View style={{
        width: '6rpx',
        height: '1rpx'
    }}></View>
              {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.marketPrice) !== actualPrice && <Text className="card-price-origin">{`¥${formatPrice(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.marketPrice)}`}</Text>}
            </View>
            {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.discount) > 0 && <View>
                {((_h = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.promotionPriceDTO) === null || _h === void 0 ? void 0 : _h.promotionAmount) && ((_j = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.promotionPriceDTO) === null || _j === void 0 ? void 0 : _j.promotionAmount) !== '.00' && Number((_k = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.promotionPriceDTO) === null || _k === void 0 ? void 0 : _k.promotionAmount) > 0 ? <View className="card-discount-width-field">
                    <LinearGradient className="card-discount-left-field" start={{
        x: 0,
        y: 1
    }} end={{
        x: 0.5,
        y: 0
    }} colors={['#FF7700', '#FF4B10']} style={{
        paddingTop: isMRN ? isAndroid ? '0rpx' : '3rpx' : '0rpx'
    }}>
                      <Image className="card-discount-img" source={{
        uri: DISCOUNT
    }}/>
                      <Text className="card-discount-width-text">{`${formatPrice(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.discount)}折起`}</Text>
                    </LinearGradient>
                    <View className="card-discount-right-field">
                      <Image className="card-curve-img" source={{
        uri: CURVE
    }}/>
                      <Text className="card-reduce-text" style={{
        fontFamily: isMRN ? 'MTNewDigitalDisplay-Regular' : 'MTNewDigitalDisplay-Regular'
    }}>{`共省¥${formatPromotionAmount((_l = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.promotionPriceDTO) === null || _l === void 0 ? void 0 : _l.promotionAmount)}`}</Text>
                    </View>
                  </View> : <LinearGradient className="card-discount-field" start={{
        x: 0,
        y: 1
    }} end={{
        x: 0.5,
        y: 0
    }} colors={['#FF7700', '#FF4B10']}>
                    <Image className="card-discount-img" source={{
        uri: DISCOUNT
    }}/>
                    <Text className="card-discount-text">{`${formatPrice(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.discount)}折起`}</Text>
                  </LinearGradient>}
              </View>}
          </View>
          <LinearGradient className="card-bottom-right-field" start={{
        x: 0.067,
        y: 0.75
    }} end={{
        x: 0.933,
        y: 0.25
    }} colors={['#FF7700', '#FF4B10']}>
            <Text className="card-bottom-right-text">{'抢购'}</Text>
          </LinearGradient>
        </View>
      </View>
    </View>;
};
export default Card;
